// =============================================================================
// OPARA v7.2 - KALICI MİMARİ: Browser-Aware API Routing
// =============================================================================
// BU DOSYA PRODUCTION'DA BOZULMAMASI İÇİN MÜHÜRLENMİŞTİR
// DEĞİŞTİRMEK İÇİN KULLANICI ONAYI GEREKLİDİR
// =============================================================================

const PRODUCTION_DOMAIN = 'opara.co';
const PRODUCTION_WWW_DOMAIN = 'www.opara.co';
const PRODUCTION_API_URL = 'https://opara.co';

/**
 * KALICI KURAL: Production domain'de çalışırken ASLA environment variable okunmaz
 * Bu fonksiyon runtime'da browser'ın hostname'ine göre karar verir
 * 
 * OPARA v7.0: X-Forwarded-Host desteği eklendi
 */
export function getBackendUrl() {
  // ==========================================================================
  // SACRED DOMAIN CHECK - EN YÜKSEK ÖNCELİK - ASLA ATLANMAZ
  // ==========================================================================
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // PRODUCTION DOMAIN İSE (www dahil): Environment variable'ları YOKSAY
    if (hostname === PRODUCTION_DOMAIN || hostname === PRODUCTION_WWW_DOMAIN) {
      console.log('[OPARA] 🔒 SACRED DOMAIN - Using hardcoded production URL');
      return PRODUCTION_API_URL;
    }
    
    // X-Forwarded-Host kontrolü (Load Balancer arkası için)
    // Not: Bu değer genellikle backend'den gelir, frontend'de erişilemeyebilir
    // Ama window.location zaten doğru hostname'i gösterir
  }
  
  // ==========================================================================
  // DİĞER ORTAMLAR (Preview, Localhost, Test)
  // ==========================================================================
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    return envUrl;
  }
  
  // Fallback - sadece development için
  return 'http://localhost:8001';
}

/**
 * API endpoint'i için tam URL
 */
export function getApiUrl() {
  return `${getBackendUrl()}/api`;
}

// Convenience exports
export const BACKEND_URL = getBackendUrl();
export const API = getApiUrl();

// =============================================================================
// DOĞRULAMA: Bu dosya yüklendiğinde hangi URL kullanıldığını logla
// =============================================================================
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const isProduction = hostname === PRODUCTION_DOMAIN || hostname === PRODUCTION_WWW_DOMAIN;
  console.log(`[OPARA API Config] Hostname: ${hostname}, Production: ${isProduction}, API URL: ${getBackendUrl()}`);
}
